import { z } from 'zod';

export const formSchema = z
  .object({
    carrier_id: z
      .string({ required_error: 'Selecione a transportadora' })
      .min(1, 'Selecione a transportadora'),
    vehicle_type_id: z
      .string({
        required_error: 'Tipo do veículo é obrigatório',
        invalid_type_error: 'Tipo do veículo deve ser um number',
      })
      .min(1, 'Tipo do veículo é obrigatório'),
    vehicle_subtype_id: z
      .string({
        required_error: 'SubTipo do veículo é obrigatório',
        invalid_type_error: 'SubTipo do veículo deve ser um number',
      })
      .min(1, 'Tipo do veículo é obrigatório'),
    vehicle_plate: z
      .string({
        required_error: 'Placa do veículo é obrigatória',
        invalid_type_error: 'Placa do veículo deve ser uma string',
      })
      .min(1, 'Placa do veículo é obrigatória')
      .max(50, 'Placa do veículo deve ter no máximo 50 caracteres'),
    renavam: z
      .string({
        invalid_type_error: 'Renavam deve ser uma string',
      })
      .optional(),
    manufacture_year: z
      .string({
        invalid_type_error: 'Ano de fabricação deve ser uma string',
      })
      .max(10, 'Ano de fabricação deve ter no máximo 10 caracteres')
      .optional(),
    vehicle_brand_id: z
      .string({
        invalid_type_error: 'Marca do veículo deve ser um number',
      })
      .optional(),
    vehicle_model_id: z
      .string({
        invalid_type_error: 'Modelo do veículo deve ser um number',
      })
      .optional(),
    tag_id: z.string({
      required_error: 'Tag é obrigatória',
      invalid_type_error: 'Tag deve ser um number',
    }),
    color: z
      .string({
        invalid_type_error: 'Cor deve ser uma string',
      })
      .min(1, 'Cor é obrigatória')
      .optional(),
    qtd_eixos: z
      .string({
        required_error: 'Quantidade de Eixo é obrigatório',
        invalid_type_error: 'Quantidade de Eixo deve ser uma string',
      })
      .min(1, 'Quantidade de Eixo é obrigatória'),
    qtd_eixos_suspenso: z
      .string({
        invalid_type_error: 'Quantidade de Eixo suspenso deve ser uma string',
      })
      .min(1, 'Quantidade de Eixo suspenso é obrigatória')
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.vehicle_type_id !== '1' &&
      (!data.tag_id || data.tag_id.trim() === '')
    ) {
      ctx.addIssue({
        path: ['tag_id'],
        message: 'Tag é obrigatória para este tipo de veículo',
        code: z.ZodIssueCode.custom,
      });
    }
  });
